import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Container = styled.div`
  position: relative;

  &:before {
    display: block;
    content: '';
    width: 100%;
    padding-top: ${props => props.ratio * 100}%;
  }
`

const Content = styled.div`
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`

export default class AspectRatio extends Component {
  static propTypes = {
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
  }

  getRatio() {
    const { height, width } = this.props

    return height / width
  }

  render() {
    const { children, ...props } = this.props
    const ratio = this.getRatio()

    return (
      <Container ratio={ratio} {...props}>
        <Content>{children}</Content>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/AspectRatio.js